import { SummaryDetail } from './summary-detail.model';

export class PolicyChangeQuoteResponse {
  getSummary: boolean;
  summaryDetail: SummaryDetail;
  requiresApprovalUWIs: Array<{longDescription: string, shortDescription: string}>;
  requiresInspectionUWIs: Array<{longDescription: string, shortDescription: string}>;

  constructor(data?: Partial<PolicyChangeQuoteResponse>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
